/* globals fbq */

// #region Imports
import { insertAsyncScript } from '@js/helpers';
import { purgeCookies } from './GatoSec/helpers';

// #endregion

export const fbPixel = {
  /**
   * Load Facebook Pixel async
   * @param {String} id pixel ID
   */
  load: (id) => {
    if (window.fbq && window.fbq.manuallyLoaded) return;

    console.warn('init facebook pixel');
    const n = window.fbq
      ? window.fbq
      : (window.fbq = function () {
          // eslint-disable-next-line no-unused-expressions
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.manuallyLoaded = !0; // custom flag to avoid loading twice
    n.version = '2.0';
    n.queue = [];
    insertAsyncScript('fbevents', `https://connect.facebook.net/en_US/fbevents.js`);
    fbq('init', id);
    fbq('track', 'PageView');
  },

  deleteCookies: () => {
    purgeCookies(['datr', 'fr', 'reg_ext_ref', 'reg_fb_gate', 'reg_fb_ref', 'sb', 'wd', 'x-src', '_fbp']);
  },
};
